import React from "react";
import Button from './Button';
import CodeSample from "./CodeSample";
import keyBy from "lodash/keyBy";


export default class CodeSampleTabs extends React.PureComponent {
  constructor(props) {
    super();
    this.byIndex = keyBy(props.tabs, 'id');
    this.state = {
      current: props.initial
    }
  }

  render() {
    const {code, label, id} = this.byIndex[this.state.current];

    return <div className="IndexPage-TabControl">
      <div className="IndexPage-Tabs">
        {this.props.tabs.map(tab => {
          return <Button key={tab.id} size={'12px'} href="" onClick={() => this.setState({current: tab.id})}>{tab.label}</Button>;
        })}
      </div>
      <CodeSample code={code} />
    </div>;
  }
}



// WEBPACK FOOTER //
// ./src/components/CodeSampleTabs.js